// Add any new languages here with their url parameter key to dynamically be called when needed
var langArray = [{
    key: 'en',
    file: '/lang/en.json'
  },
  {
    key: 'sp',
    file: '/lang/sp.json'
  }
];

// Clear Local storage on page load to repopulate it with any new values
langArray.forEach(function (item) {
  localStorage.removeItem('pf-' + item.key + '-json');
  localStorage.setItem('pf-lang-loaded', "0");
});

// Create a promise to handle if we need to ajax the language jsons in or if we can just pull from local storage
function loadLanguage(resolve, reject) {
  var $deferred = $.Deferred(); 
  var langLoaded = localStorage.getItem('pf-lang-loaded');

  if (langLoaded === "0") {
    console.log('loading Languages');
    $.ajax({
      cache: false,
      url: '/lang/' + langLookup() + '.json',
      success: function (response) {
        localStorage.setItem('pf-' + langLookup() + '-json', JSON.stringify(response));
        localStorage.setItem('pf-lang-loaded', "1");
        $deferred.resolve();
      },
      error: function (textStatus, errorThrown) {
        var err = {
          key: langLookup(),
          textStatus: textStatus,
          errorThrown: errorThrown
        };
        $deferred.reject(err);
      }
    });
  }
  return $deferred;
}

$(document).ready(function () {
  loadLanguage().done(function (results) {
    htmlTranslator();
    // Find an replace placeholder text for form inputs on page load
    $(".pfTranslateInput").each(function (index) {
      var translation = textTranslate(this, langLookup());
      $(this).attr('placeholder', translation);
    });
    overrideReplacement();
  });
  console.log("translation loaded");
});

function overrideReplacement() {
  var elements;
  if (langLookup() === 'en') {

    elements = document.getElementsByClassName('spanish-replacement');
    while (elements.length > 0) {
      elements[0].parentNode.removeChild(elements[0]);
    }
    if (document.getElementById("spanish-replacement")) {
      document.getElementById("spanish-replacement").remove();
    }
  } else if (langLookup() === 'sp') {
    elements = document.getElementsByClassName('english-replacement');
    while (elements.length > 0) {
      elements[0].parentNode.removeChild(elements[0]);
    }
    if (document.getElementById("english-replacement")) {
      document.getElementById("english-replacement").remove();
    }
  }
}

function htmlTranslator() {
  // Find an replace <span> tags with the class pfTranslate on page load
  $(".pfTranslate").each(function (index) {
    var translation = textTranslate(this, langLookup());
    $(this).replaceWith(translation);
  });
}

// Return language of the site based on parameter if present, otherwise location
function langLookup(alt) {
  var language = 'en';
  var urlParam = common.getParameterFromUrl('lang');
  if (urlParam) {
    language = urlParam;
  }
  // Reporting needs to be backwards compatible
  if (alt === 'alt') {
    if (language === 'es') {
      language = 'sp';
    }
  }
  return language
}

// Break apart data prop and navigate to the json object in question
function findProp(obj, path) {
  var args = path.split('.'),
    i, l;

  for (i = 0, l = args.length; i < l; i++) {
    if (!obj.hasOwnProperty(args[i]))
      return;
    obj = obj[args[i]];
  }

  return obj;
}

// Provide an HTML element and the site language to return the correct text based on data-lang of element
function textTranslate(elem, lang) {
  var langJson = JSON.parse(localStorage.getItem('pf-' + lang + '-json'));
  var payload = null;
  var lookup = $(elem).data("lang");

  payload = findProp(langJson, lookup);

  if (payload) {
    return payload;
  } else {
    debug("kiosk:translate")(`textTranslate error: Lookup: ${lookup}`);
    return 'unknown';
  }
}

// Function for use on other js pages to return translated text
function pfFetchTranslation(lookup, replacements) {
  var lang = langLookup();
  var langJson = JSON.parse(localStorage.getItem('pf-' + lang + '-json'));
  var payload = null;

  payload = findProp(langJson, lookup);
  if (payload && replacements) {
    replacements.forEach(function replace(item) {
      payload = payload.replace(new RegExp("#(.*?)#", ""), item);
    });
  }

  if (payload) {
    return payload;
  } else {
    debug("kiosk:translate")(`textTranslate error: Lookup: ${lookup}`);
    return 'unknown';
  }
}

// Return the DateTimeFormat used by moments depending on language.  Defaults to american format
function dateTimeFormat(time, format) {
  if (format === 'full') {
    if (langLookup() === 'en') {
      return time.format('MM/DD/YYYY h:mma');
    } else if (langLookup() === 'sp') {
      return time.format('DD/MM/YYYY h:mma');
    }
  }
}

function toggleButton(text, button) {
  var buttonText = button.text();

  button.prop('disabled', true);
  button.text(text);

  setTimeout(function () {
    button.prop('disabled', false);
    button.text(buttonText);
  }, 3000);
}

function getUrlParameter(sParam) {
  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
};

function updateURLParameter(url, param, paramVal) {
  var newAdditionalURL = "";
  var tempArray = url.split("?");
  var baseURL = tempArray[0];
  var additionalURL = tempArray[1];
  var temp = "";
  if (additionalURL) {
    tempArray = additionalURL.split("&");
    for (var i = 0; i < tempArray.length; i++) {
      if (tempArray[i].split('=')[0] !== param) {
        newAdditionalURL += temp + tempArray[i];
        temp = "&";
      }
    }
  }

  var rows_txt = temp + "" + param + "=" + paramVal;
  return baseURL + "?" + newAdditionalURL + rows_txt;
}

function languageToggle(language) {
  var url = "";
  var currentUrl = document.location.href;
  var langParam = getUrlParameter('lang');
  if (langParam) {
    url = updateURLParameter(currentUrl, 'lang', language);
  } else {
    if (currentUrl.indexOf('?') === -1) {
      url = document.location.href + '?lang=' + language;
    } else {
      url = document.location.href + '&lang=' + language;
    }
  }
  document.location = url;
}

function commonSkinType() {
  common.defaults.skinTypes["Type 1"].name = pfFetchTranslation('skinType.type1.name');
  common.defaults.skinTypes["Type 2"].name = pfFetchTranslation('skinType.type2.name');
  common.defaults.skinTypes["Type 3"].name = pfFetchTranslation('skinType.type3.name');
  common.defaults.skinTypes["Type 4"].name = pfFetchTranslation('skinType.type4.name');
  common.defaults.skinTypes["Type 5"].name = pfFetchTranslation('skinType.type5.name');
  common.defaults.skinTypes["Type 6"].name = pfFetchTranslation('skinType.type6.name');
  common.defaults.skinTypes["Type 1"].desc = pfFetchTranslation('skinType.type1.desc');
  common.defaults.skinTypes["Type 2"].desc = pfFetchTranslation('skinType.type2.desc');
  common.defaults.skinTypes["Type 3"].desc = pfFetchTranslation('skinType.type3.desc');
  common.defaults.skinTypes["Type 4"].desc = pfFetchTranslation('skinType.type4.desc');
  common.defaults.skinTypes["Type 5"].desc = pfFetchTranslation('skinType.type5.desc');
  common.defaults.skinTypes["Type 6"].desc = pfFetchTranslation('skinType.type6.desc');
}

function langSwapControl() {
  var lang = langLookup();

  $('.language-dropdown #' + lang).addClass('isDisabled');
}

function siteLoadCheck() {
  if (typeof(pfKioskAdmin) != "undefined") {
    if (pfKioskAdmin.loaded) {
      toggleLanguageControl();
    } else {
      setTimeout(function () {
        siteLoadCheck();
      }, 1000);
    }
  } else if (typeof(pfKiosk) != "undefined") {
    if (pfKiosk.loaded) {
      toggleLanguageControl();
    } else {
      setTimeout(function () {
        siteLoadCheck();
      }, 1000);
    }
  }
}


function toggleLanguageControl() {
  if (common.configData.languageControl) {
    if (common.configData.languageControl === true) {
      // $('.language-dropdown').addClass('activeControl');
    } else {
      $('.language-dropdown').removeClass('activeControl');
    }
  }
}
